import { seoKeywords } from '../home/Home.seo';

export const servicesSeo = {
  title: 'Rumble Fish | Services',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'You bring the product vision. We bring product-building expertise. Blockchain | AWS Cloud | Fintech solutions',
    },
  ],
};
